module.exports = "<!-- <div style=\"min-width: 1024px; overflow-y: hidden;\">\r\n  <iframe style=\"width: 100%; margin-top:50px; height: 100vh;\" src=\"https://syncode.movidesk.com\">\r\n  </iframe>\r\n</div> -->"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-ajuda/tela-ajuda.component.html
// module id = ../../../../../src/app/area-cliente/portal/tela-ajuda/tela-ajuda.component.html
// module chunks = 1